export const makeRatingJsonLd = ({ rating, count }) =>
  `"aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "${rating}",
    "reviewCount": "${count}"
  }`;
